// extracted by mini-css-extract-plugin
export default {"arrow":"ArrowButton_arrow__mjGda","arrow-open":"ArrowButton_arrow-open__i56bn"};